import React, { useEffect, useState } from 'react';
import NFTView from '../../components/NFTView';
import useBrain from '../../hooks/brain';
import { NFTDetails } from '../../types';
import { useWallet } from '../../wallet-context';
import WalletConnect from '../WalletConnect';
import Layout from '../../components/Layout';
import Card from '../../components/Card';

const History: React.FC = () => {
  const brain = useBrain();
  const [loading, setLoading] = useState(false);
  const [nfts, setNfts] = useState<NFTDetails[]>();
  const { walletAddress } = useWallet();

  useEffect(() => {
    const load = async () => {
      if (!walletAddress) {
        return;
      }
      setLoading(true);

      try {
        setNfts(await brain.getNfts(walletAddress));
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [walletAddress]);

  if (!walletAddress) {
    return (
      <WalletConnect />
    );
  }

  if (loading) {
    return (
      <div>
        <p>loading</p>
      </div>
    );
  }


  if (nfts) {
    return (
      <Layout>
        <main>
          <section className='md:container md:mx-auto bg-gray-50'>
            <div className='flex flex-col items-center justify-center text-center p-7'>
              <h1 className='text-2xl md:text-4xl'>Interaction collection</h1>
              <h5>{`total = ${nfts.length}`}</h5>
            </div>
            <div className="container my-12 mx-auto px-4 md:px-12">
              <div className="flex flex-wrap -mx-1 lg:-mx-4">
                {nfts.map((nft) => (
                  <div key={nft.index} className="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">
                    <Card description={nft.description} image={nft.image} />
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>
      </Layout>
    );
  }

  return null;
};

export default History;
